export type AppRole = 'admin' | 'user';

export const AUTH_TOKEN_KEY = 'pooram_admin_token';
export const AUTH_ROLE_KEY = 'pooram_auth_role';

export function getStoredAuth(): { token: string; role: AppRole | '' } {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return { token: '', role: '' };
  }
  const token = localStorage.getItem(AUTH_TOKEN_KEY) ?? '';
  const roleRaw = localStorage.getItem(AUTH_ROLE_KEY);
  const role = roleRaw === 'admin' || roleRaw === 'user' ? roleRaw : '';
  return { token, role };
}

/** Persist a session token + role after a successful login. */
export function storeAuth(token: string, role: AppRole): void {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') return;
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_ROLE_KEY, role);
}

/**
 * Clear local auth state and optionally call the server-side /api/logout
 * to invalidate the Durable Object session (CRIT-4).
 */
export async function clearAuth(token?: string): Promise<void> {
  if (token) {
    try {
      await fetch('/api/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch {
      // Best-effort — always clear local state
    }
  }
  if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_ROLE_KEY);
  }
}
